var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.$store.state.webNavigator == "pc"
      ? _c("div", { staticClass: "homeDoctorvideo" }, [
          _c("div", { staticClass: "home-doctorvideo marginAuto max1720" }, [
            _c("div", [
              _c("div", { staticClass: "flexSpace" }, [
                _vm._m(0),
                _c(
                  "div",
                  { staticClass: "goto displayIB" },
                  [
                    _c(
                      "vue-link",
                      {
                        attrs: {
                          to: {
                            path:
                              "/encyclopeDias/" +
                              _vm.urlType +
                              "-0-1-" +
                              _vm.urlName +
                              ".html"
                          }
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "more-icon",
                          attrs: {
                            src:
                              "https://jusewebapp.zmelo.com/zml-gw/pc_home/goto.png",
                            alt: "",
                            title: ""
                          }
                        })
                      ]
                    )
                  ],
                  1
                )
              ]),
              _c(
                "div",
                { staticClass: "doctorvideo-list" },
                _vm._l(_vm.videolist, function(item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass:
                        "displayIB positionRE doctorvideo-bar pointEr",
                      class: (index + 1) % 3 == 0 ? "doctorvideo-last-bar" : "",
                      on: {
                        click: function($event) {
                          return _vm.playVideo(item.videoUrl, item.title)
                        }
                      }
                    },
                    [
                      _c("img", {
                        staticClass: "doctorvideo-backimg",
                        attrs: {
                          src: _vm.myFun(item.coverImg)
                            ? _vm.myFun(item.coverImg)
                            : "",
                          alt: item.title,
                          title: ""
                        }
                      }),
                      _c("img", {
                        staticClass: "video-start positionAB video-min-start",
                        attrs: {
                          src:
                            "https://jusewebapp.zmelo.com/zml-gw/pc_home/startmin.png",
                          alt: "",
                          title: ""
                        }
                      }),
                      _c(
                        "p",
                        {
                          staticClass: "col444444 doctorvideo-Tlt overflowText"
                        },
                        [_vm._v(_vm._s(item.title))]
                      )
                    ]
                  )
                }),
                0
              )
            ])
          ])
        ])
      : _c("div", { staticClass: "phone-page" }, [
          _vm._m(1),
          _c(
            "div",
            { staticClass: "video-list flexStart" },
            _vm._l(_vm.videolist, function(item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "displayIB pointEr doctorvideo-last-bar",
                  on: {
                    click: function($event) {
                      return _vm.playVideo(item.videoUrl, item.title)
                    }
                  }
                },
                [
                  _c("div", { staticClass: "doctorvideo-bar positionRE" }, [
                    _c("img", {
                      staticClass: "doctorvideo-backimg",
                      attrs: {
                        src: _vm.httptype(item.coverImg),
                        alt: item.title,
                        title: ""
                      }
                    }),
                    _c("img", {
                      staticClass: "video-start positionAB video-min-start",
                      attrs: {
                        src:
                          "https://jusewebapp.zmelo.com/zml-gw/pc_home/startmin.png",
                        alt: "",
                        title: ""
                      }
                    })
                  ]),
                  _c(
                    "p",
                    { staticClass: "doctorvideo-Tlt firstText overflowText" },
                    [_vm._v(_vm._s(item.title))]
                  )
                ]
              )
            }),
            0
          )
        ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "part-title list-tlt displayIB" }, [
      _vm._v("\n            减肥视频\n            "),
      _c("span", { staticClass: "list-tlt-tip" }, [_vm._v("-")]),
      _vm._v("\n            专家教你健康瘦身\n          ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "PhoneHome-title" }, [
      _vm._v("减肥视频 "),
      _c("span", { staticClass: "col00CDA2" }, [_vm._v("-")]),
      _c("br"),
      _vm._v(" 专家教你健康瘦身")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b00ca042", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b00ca042","hasScoped":true,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/hometest/comPonents/homeDoctorvideo/homeDoctorvideo.vue
// module id = 981
// module chunks = 1